module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-42.5fcfa84f.png";